import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

const PURCHASE_ROLES = new Set(['purchase', 'purchase_head', 'purchase_manager']);
const ADMIN_ROLES = new Set(['admin', 'owner', 'super_admin']);

/** Keep saved links on the employee's own side of the negotiation. */
export function VedaRenegotiationGuard({ mode, children }: {
  mode: 'legacy' | 'purchase' | 'respond';
  children: ReactNode;
}) {
  const user = useAuthStore(s => s.user);
  const { enquiryId } = useParams();
  if (!user) return null;
  const role = user.role?.name?.toLowerCase() ?? '';
  const purchase = PURCHASE_ROLES.has(role);
  const admin = ADMIN_ROLES.has(role);
  if (mode === 'legacy' && !admin) {
    return <Navigate to={purchase ? '/veda-agro/enquiry-inbox' : '/veda-agro/renegotiations'} replace />;
  }
  if (mode === 'purchase' && !purchase && !admin) {
    return <Navigate to="/veda-agro/renegotiations" replace />;
  }
  if (mode === 'respond' && purchase) {
    return <Navigate to={`/veda-agro/enquiries/${enquiryId}`} replace />;
  }
  return <>{children}</>;
}
